// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gZuN","left":"styles_left__3MWKy","desktopActions":"styles_desktopActions__F0Nnr","title":"styles_title__1hK-A"};